// faqData.js

const faqData = {
  "/": {
    heading: "Got Questions?",
    subheading: "We’ve Got Answers",
    items: [
      {
        title: "Product & Usage",
        question: "How does Gapalyze help my business grow?",
        answer: "Gapalyze provides clear sales, ads, and performance insights so you can make smarter, data-driven decisions and improve ROI."
      },
      {
        title: "Product & Usage",
        question: "Which marketplaces or platforms does Gapalyze support?",
        answer: "Currently, Gapalyze integrates with Amazon Seller Central."
      },
      {
        title: "Product & Usage",
        question: "How often is the data updated?",
        answer: "Your data refreshes automatically every payment cycle to keep your dashboards current and reliable."
      },
      {
        title: "Security & Privacy",
        question: "Is there a mobile app?",
        answer: "Yes, we offer a mobile app that lets you manage and monitor your account on the go."
      },
      {
        title: "Support & Onboarding",
        question: "Can I cancel anytime?",
        answer: "Yes, you can cancel your subscription at any time from your account settings."
      },
      {
        title: "Plans & Billing",
        question: "Does the free plan include everything?",
        answer: "No, the free plan includes core features. Advanced functionality is available on paid plans."
      },
      {
        title: "Security & Privacy",
        question: "Is my data secure?",
        answer: "Yes, your data is protected with enterprise-grade security and encryption protocols."
      },
      {
        title: "Security & Privacy",
        question: "What about data privacy?",
        answer: "Absolutely. We follow strict data privacy guidelines and conduct regular security audits."
      },
      {
        title: "Security & Privacy",
        question: "How is my data protected?",
        answer: "All data transfers are encrypted using SSL and stored securely in compliance with industry regulations."
      },
      {
        title: "Security & Privacy",
        question: "Is my data safe?",
        answer: "We prioritize your data privacy and implement strong measures to keep it safe at all times."
      }
    ]

  },

  "/pricing": {
    heading: "Everything you need to know about the product",
    subheading: "Got questions? We’ve answered the most common ones below.",
    items: [
      {
        question: "Is there a mobile app?",
        answer: "Yes, we offer a mobile app on iOS and Android.",
      },
      {
        question: "Can I cancel anytime?",
        answer: "Absolutely! You can cancel at any time from your account settings.",
      },
      {
        question: "Does the free plan include everything?",
        answer: "The free plan includes basic features, not everything.",
      },
      {
        question: "Is my data secure?",
        answer: "We use industry-standard encryption and security protocols.",
      },
      {
        question: "Do I get customer support?",
        answer: "Yes, even free plans get email support.",
      },
      {
        question: "How often is the data updated?",
        answer: "Data is updated in real-time.",
      },
      {
        question: "Is there a desktop version?",
        answer: "Yes, the product is web-based and works on desktops.",
      },
      {
        question: "Can I upgrade later?",
        answer: "Yes, you can upgrade any time from your account settings.",
      },
    ],
  },
};

export default faqData;
